import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M 12 5.5 a 2.6 2.6 0 1 0 0 5.2 a 2.6 2.6 0 0 0 0 -5.2 Z M 7.4 8.1 a 4.6 4.6 0 1 1 9.2 0 a 4.6 4.6 0 0 1 -9.2 0 Z M 2.38 18.986 c 1.574 -2.625 4.891 -4.21 9.62 -4.21 c 4.729 0 8.046 1.585 9.62 4.21 a 1 1 0 1 1 -1.715 1.028 c -1.078 -1.797 -3.57 -3.238 -7.905 -3.238 c -4.335 0 -6.827 1.441 -7.905 3.238 A 1 1 0 1 1 2.38 18.986 Z"
  />,
  'UserProfile3'
)
